<template>
<div class="grid-print">
  <icon class="first-icon" icon="file-excel" @click="showModal('csv')"></icon>
  <icon icon="file-pdf" @click="showModal('pdf')"></icon>
  <b-modal ref="formmodal" :title="$t(formName)" ok-title="submit" hide-footer>
    <div class="d-block">
      <div role="group" class="b-form-group form-group">
        <div class="form-row mb-lg" v-if="showPdfOrientation">
          <div class="col-sm-12">
            <b-form-group :label="$t('PAPERORIENTATION')">
              <b-form-radio-group id="radio-group-2" v-model="paperOrientation" name="radio-sub-component">
                <b-form-radio value="p">{{$t('PORTRAIT')}}</b-form-radio>
                <b-form-radio value="l">{{$t('LANDSCAPE')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
        </div>

        <div class="form-row mb-lg">
          <template v-for="(item, index) in formData">
            <div class="col-sm-6">
              <b-form-checkbox plain id="checkbox1" v-model="formData[index]" value="1">{{$t(index.toUpperCase())}}</b-form-checkbox>
            </div>
          </template>
        </div>

      </div>
    </div>
    <div class="text-right">
      <b-btn class="mt-3" variant="secondary mr-lg" @click="hideModal">{{$t('CANCEL')}}</b-btn>
      <b-btn class="mt-3" variant="primary" @click="exportData(formData)">{{$t('EXPORT')}}</b-btn>
    </div>
  </b-modal>
</div>
</template>

<style>
.grid-print {
  position: absolute;
  top: 0px;
  right: 30px;
  cursor: pointer;
}

.grid-print i {
  margin: 5px;
}

.first-icon {
  margin-right: 10px;
}
</style>

<script>
import ExportDataApi from '@/api/ExportData'

export default
{
  name: 'GridPrint',
  props: ['tableData', 'filters', 'method'],
  data: function()
  {
    return {
      formName: 'EXPORTTOXLS',
      showPdfOrientation: false,
      paperOrientation: 'p',
      type: 'csv',
      formData:
      {}
    }
  },
  mounted()
  {
    var me = this;
  },
  methods:
  {
    showModal(type)
    {
      var me = this;

      me.formName = 'EXPORTTOXLS';
      me.showPdfOrientation = false;
      me.type = 'csv';
      if (type == 'pdf')
      {
        me.type = 'pdf'
        me.formName = 'EXPORTTOPDF';
        me.showPdfOrientation = true;
      }

      var dataForFields = me.tableData[0];
      for (var key in dataForFields)
      {
        me.$set(me.formData, key, 1);
      }

      this.$refs.formmodal.show()
    },
    async exportData(item)
    {
      var me = this;
      try
      {
        var data = await ExportDataApi.exportData(
        {
          'type': me.type,
          'fields': item,
          'filters': me.filters,
          'method': me.method,
          'paperOrientation': me.paperOrientation
        });


      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    hideModal()
    {
      var me = this;
      this.$refs.formmodal.hide();
    }
  }
}
</script>
